import { EducationListItemType } from '@/modules/education/Education.constants';
import { EducationSlideTrowser } from '@/modules/education/EducationSlideTrowser/EducationSlideTrowser';
import { LuminaryThemeProvider } from '@/styles/themes/LuminaryThemeProvider';

interface PresentationEditEducationalSlideTrowserProps {
  /**
   * The education slide to edit, resolved from the presentation page kind via
   * `PAGE_KIND_TO_EDUCATION_SLIDE_ID`. This is what the trowser uses to look up
   * the tenant override / default content for the page.
   */
  educationSlideId: EducationListItemType;
  /**
   * The page being edited within the slide. Multi-page education slides render
   * one wrapper per page, so open the editor on the matching page rather than
   * always starting at the first.
   */
  pageIndex: number;
  onClose: () => void;
}

/**
 * Opens the full-screen education-slide editor for a presentation slide.
 *
 * Saving is handled inside the trowser's own Save button, which refetches
 * `GetEducationPageEditor` — the same query that drives the slide via
 * `EducationSlideOverridesProvider` — so the edited content flows back to the
 * slide with no extra refetch wiring here.
 *
 * The slide renders under `CustomerThemeProvider`, so wrap the editor in
 * `LuminaryThemeProvider` to keep its chrome Luminary-branded rather than
 * inheriting the tenant brand (the trowser re-wraps its own slide preview in
 * the customer theme, so the preview still shows tenant branding).
 */
export function PresentationEditEducationalSlideTrowser({
  educationSlideId,
  pageIndex,
  onClose,
}: PresentationEditEducationalSlideTrowserProps) {
  return (
    <LuminaryThemeProvider>
      <EducationSlideTrowser
        isOpen
        onClose={onClose}
        educationSlideId={educationSlideId}
        initialSlideIndex={pageIndex}
      />
    </LuminaryThemeProvider>
  );
}
